<template>
    <div>
        <pleitos
            :pleitosServicos="obterDataServicos()"
            rotaDetalhar="Pleitos_Ucic_Detalhar"
            rotaListagem="Pleitos_Ucic"
            rotaInserir="Pleitos_Ucic_Inserir"
            rotaAtualizar="Pleitos_Ucic_Atualizar"
            :temAcessoDetalhar="$temAcessoView('PLEITOS-UCIC-00')"
            :permiteInserir="$temAcessoView('PLEITOS-UCIC-01')"
            :permiteAtualizar="$temAcessoView('PLEITOS-UCIC-01')"
            :permiteExcluir="$temAcessoView('PLEITOS-UCIC-02')"
        ></pleitos>
        <router-view></router-view>
    </div>
</template>

<script>
import PleitosServicos from './PleitosServicos'
import Pleitos from '../componentes/PleitosLista'

export default {
    components: {
        Pleitos
    },

    methods: {
        obterDataServicos() {
            return PleitosServicos
        }
    },
}
</script>

